import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { DashboardSettingsProvider, useDashboardSettings } from "features/dashboard/settings/store";
import { useAuthUser } from "lib/useAuthUser";
import { LoadingPage } from "../LoadingPage";
import { normalizeDashboardPortal } from "features/dashboard/portal";
import RedirectStatusPage, { RestrictedDashboardPage } from "../../pages/main/Status/RedirectStatusPage";

function DashboardPermissionGuard({ children }) {
  const s = useDashboardSettings();

  useEffect(() => {
    const tint = s.dashboardTint || "gray";
    document.documentElement.setAttribute("data-dashboard-tint", tint);
  }, [s.dashboardTint]);

  // A confirmed 403 should render feedback immediately; refetching here causes a loading loop.
  if (s.denied) {
    if (s.fallbackPortal && s.fallbackPortal !== s.portal) {
      return <RedirectStatusPage to={`/dashboard/${s.fallbackPortal}`} eyebrow="Portal diferente" title="Te llevaremos al portal correcto" description="Tu cuenta sí tiene acceso al equipo de Arawaks, pero desde otro portal." />;
    }
    return <RestrictedDashboardPage/>;
  }

  // still loading context
  if (!s.ready) return <LoadingPage />;

  return children;
}

export function DashboardGuard({ children }) {
  const user = useAuthUser();
  const location = useLocation();
  const requestedPortal = normalizeDashboardPortal(location.pathname.split("/")[2]);

  // Firebase loading
  if (user === undefined) return <LoadingPage />;

  // Not logged in
  if (!user) return <RedirectStatusPage to="/registro" eyebrow="Sesión necesaria" title="Primero necesitamos identificarte" description="Inicia sesión para comprobar si tienes acceso al dashboard." actionLabel="Ir a iniciar sesión" />;

  // Logged in -> now load dashboard context and check permission
  return (
    <DashboardSettingsProvider requestedPortal={requestedPortal}>
      <DashboardPermissionGuard>{children}</DashboardPermissionGuard>
    </DashboardSettingsProvider>
  );
}

export default DashboardGuard;
